<template>
  <div v-bind="$attrs" class="modal__container z-130 relative u-center h-full w-full" v-on="$listeners">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>
